module.exports = __webpack_public_path__ + "static/media/ab_notify_client_sv.e8ceb712.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ab_notify_client_sv.svg
// module id = 1261
// module chunks = 0